import React, { useEffect, useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { AiOutlineTrophy } from 'react-icons/ai';
import { Loader } from '@/components/custom/loader';
import { IconWrapper } from '@/components/custom/icon';
import { Card, CardBody, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow, TableUser, TableUserContent, TableUserTitle } from '@/components/ui/table';

export function TableInstitutions({ institutions, loading, error }) {
  const [sortDirection, setSortDirection] = useState('desc');

  const ordenedInstitutions = institutions?.sort((a, b) => {
    if (sortDirection === 'asc') {
      return a.score - b.score;
    }
    if (sortDirection === 'desc') {
      return b.score - a.score;
    }
  });

  useEffect(() => {
    if (error) toast.error('Erro ao carregar ranking');
  }, []);

  if (loading) return <Loader />;

  return (
    <Card
      className="animate-fade-in bg-neutral-bright"
      hover={false}
    >
      <CardContent>
        <CardBody>
          <Table className="min-w-[720px]">
            <TableHeader>
              <TableRow>
                <TableHead
                  score="column"
                  className="w-[80px]"
                >
                  Posição
                </TableHead>
                <TableHead
                  score="column"
                  className="w-[44px]"
                />
                <TableHead score="column">Instituição</TableHead>
                <TableHead
                  score="column"
                  className="w-[136px]"
                >
                  Pontuação total{' '}
                  <IconWrapper
                    size="sm"
                    className="cursor-pointer"
                    onClick={() => setSortDirection(prev => (prev === 'desc' ? 'asc' : 'desc'))}
                  >
                    {sortDirection === 'desc' ? <FiChevronDown /> : <FiChevronUp />}
                  </IconWrapper>
                </TableHead>
              </TableRow>
            </TableHeader>

            <TableBody>
              {ordenedInstitutions?.map((item, i) => (
                <TableRow key={i}>
                  <TableHead scope="row">{i + 1}</TableHead>
                  <TableCell>
                    {i === 0 && (
                      <AiOutlineTrophy
                        size={16}
                        className="text-[#FFD661]"
                      />
                    )}
                    {i === 1 && (
                      <AiOutlineTrophy
                        size={16}
                        className="text-[#8894AC]"
                      />
                    )}
                    {i === 2 && (
                      <AiOutlineTrophy
                        size={16}
                        className="text-[#D3681A]"
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    <TableUser>
                      <TableUserContent>
                        <TableUserTitle>{item.name}</TableUserTitle>
                      </TableUserContent>
                    </TableUser>
                  </TableCell>
                  <TableCell className="text-right">{item.score}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardBody>
      </CardContent>
    </Card>
  );
}
